import { render } from "./syncProduct.vue?vue&type=template&id=7a2d5890&scoped=true"
import script from "./syncProduct.vue?vue&type=script&lang=js"
export * from "./syncProduct.vue?vue&type=script&lang=js"

import "./syncProduct.vue?vue&type=style&index=0&id=7a2d5890&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a2d5890"],['__file',"src/views/brandProduct/components/syncProduct.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a2d5890"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a2d5890', __exports__)) {
    console.log('reload')
    api.reload('7a2d5890', __exports__)
  }
  
  module.hot.accept("./syncProduct.vue?vue&type=template&id=7a2d5890&scoped=true", () => {
    console.log('re-render')
    api.rerender('7a2d5890', render)
  })

}


export default __exports__